import AbsComponent from "../AbsComponent";

export default class CharHeaderButtons extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);
    }

    setting(_d, _parent){
        _d = _d.data;

        // let config = this.store.getState().config;
        let itsMe = window.myChar.id === _d.id;
        if (itsMe) return ``;


        let lang = $('html').attr('lang') || 'ko';

        let templ = $(`
            <div class="buttons">
                ${!this.store.getState().isAllowed?'':`
                <a href="#" class="compare-btn">${this.l10n.compare}</a>
                `}
                <a href="nc://bns.CharInfo/Whisper?pcName=${_d.name}">${this.l10n.whisper}</a>
                <a href="nc://bns.CharInfo/InviteParty?pcName=${_d.name}">${this.l10n.inviteParty}</a>
                ${(lang==='ko')?`
                <a href="nc://bns.CharInfo/AddFriend?pcName=${_d.name}&amp;world=${_d.server_id}">${this.l10n.applyFriend}</a>
                <a href="nc://bns.CharInfo/Follow?pcName=${_d.name}">${this.l10n.subscribe}</a>
                `:``}
            </div>
        `);

        $(_parent).append(templ);

        templ.find('.compare-btn').on('click', e => {
            this.router.goMultiParam({compare: 'true'});
            return false;
        });
    }

    addEvents(){
    }

} // end of class